import {
  Report as ReportType,
  ReportHistory as ReportHistoryType,
} from 'data/types/report';
import { parse, format } from 'date-fns';

import { INTERFACE_DAY_FORMAT } from 'utils/date';

export const normalizeReport = (data: ReportType) => ({
  id: data.id,
  orgId: data.orgId,
  startDate: format(
    parse(data.startDate, 'yyyy-MM-dd', new Date()),
    INTERFACE_DAY_FORMAT,
  ),
  endDate: format(
    parse(data.endDate, 'yyyy-MM-dd', new Date()),
    INTERFACE_DAY_FORMAT,
  ),
  reportType: data.reportType,
  fileUrl: data.fileUrl,
  created: data.created,
  createdLocalised: new Date(data.created).toLocaleString(),
});

export type Report = ReturnType<typeof normalizeReport>;

export const normalizeReportHistory = (data: ReportHistoryType) => ({
  reports: data.reports.map(normalizeReport),
  cursor: data.cursor,
});

export type ReportHistory = ReturnType<typeof normalizeReportHistory>;
